import { render } from "./mzixun.vue?vue&type=template&id=22e094a8&scoped=true"
import script from "./mzixun.vue?vue&type=script&lang=js"
export * from "./mzixun.vue?vue&type=script&lang=js"

import "./mzixun.vue?vue&type=style&index=0&id=22e094a8&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e094a8"]])

export default __exports__